import { MessageCircle, Mail, Share2 } from "lucide-react";

const enc = encodeURIComponent;

export function ShareButtons({ text, testPrefix = "share", compact = false }) {
  const disabled = !text?.trim();
  const open = (url) => window.open(url, "_blank", "noopener,noreferrer");
  const subject = text ? text.trim().split(/\s+/).slice(0, 8).join(" ") : "";
  const cls = compact ? "btn-ghost text-xs !px-3 !py-1.5" : "btn-ghost text-xs";
  return (
    <div className="flex flex-wrap gap-2" data-testid={`${testPrefix}-buttons`}>
      <button disabled={disabled} onClick={() => open(`https://wa.me/?text=${enc(text)}`)} data-testid={`${testPrefix}-whatsapp`} className={cls}>
        <MessageCircle size={13} /> WhatsApp
      </button>
      <button disabled={disabled} onClick={() => { window.location.href = `mailto:?subject=${enc(subject)}&body=${enc(text)}`; }} data-testid={`${testPrefix}-email`} className={cls}>
        <Mail size={13} /> Email
      </button>
      {typeof navigator !== "undefined" && navigator.share && (
        <button disabled={disabled} onClick={() => navigator.share({ text }).catch(() => {})} data-testid={`${testPrefix}-more`} className={cls}>
          <Share2 size={13} /> More
        </button>
      )}
    </div>
  );
}
